export default {
  'driver-out': '운전사 출발',
  'data-unavailable': '데이터 없음',
  delivered: '배송 완료',
  'wrong-address': '잘못된 주소',
  'not-present': '부재중',
  'order-canceled': '주문 취소됨',
  'delivery-attempted': '배송 시도됨',
  rescheduled: '재예약됨',
  'date-unavailable': '날짜 정보 없음',
}
